import { render, staticRenderFns } from "./comp_BannerItem.vue?vue&type=template&id=1bdaa30e&scoped=true"
import script from "./comp_BannerItem.vue?vue&type=script&lang=js"
export * from "./comp_BannerItem.vue?vue&type=script&lang=js"
import style0 from "./comp_BannerItem.vue?vue&type=style&index=0&id=1bdaa30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdaa30e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
